"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Namespace = void 0;
/**
 * @hidden
 *
 * Represents a namespace within an Entity with the purpose of grouping related functionality
 */
class Namespace {
    /**
     * @hidden
     */
    constructor(parent, context) {
        this.parent = parent;
        this.context = context;
    }
}
exports.Namespace = Namespace;
//# sourceMappingURL=Namespace.js.map